import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { api, errMsg } from "@/lib/api";
import { PROPERTY_VALUES, TIMELINES } from "@/lib/constants";
import { toast } from "sonner";
import { CheckCircle2 } from "lucide-react";

const empty = { client_name: "", client_email: "", client_phone: "", property_value: "", timeline: "", notes: "" };

export const ReferralDialog = ({ open, onOpenChange, qi }) => {
  const [f, setF] = useState(empty);
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/referrals", { ...f, profile_id: qi.profile_id });
      setSent(true);
      setF(empty);
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(v) => { onOpenChange(v); if (!v) setSent(false); }}>
      <DialogContent className="bg-ink-2 border-white/10 rounded-[28px] max-w-lg text-white" data-testid="referral-dialog">
        <DialogHeader>
          <span className="eyebrow">Client referral</span>
          <DialogTitle className="font-display text-2xl font-black">Refer a client to {qi.company_name}</DialogTitle>
          <DialogDescription className="text-white/50">The referral lands in this QI's inbox tagged with your name and firm. Only share client details you have permission to share.</DialogDescription>
        </DialogHeader>
        {sent ? (
          <div className="py-8 text-center" data-testid="referral-success">
            <CheckCircle2 className="mx-auto text-qi-emerald" size={44} />
            <p className="font-display text-xl font-bold mt-4">Referral sent</p>
            <p className="text-sm text-white/50 mt-1">Track its status from your dashboard.</p>
          </div>
        ) : (
          <form onSubmit={submit} className="grid grid-cols-2 gap-3 mt-2">
            <input required placeholder="Client name" className="field col-span-2 sm:col-span-1" value={f.client_name} onChange={set("client_name")} data-testid="referral-client-name-input" />
            <input required type="email" placeholder="Client email" className="field col-span-2 sm:col-span-1" value={f.client_email} onChange={set("client_email")} data-testid="referral-client-email-input" />
            <input placeholder="Client phone (optional)" className="field col-span-2 sm:col-span-1" value={f.client_phone} onChange={set("client_phone")} data-testid="referral-client-phone-input" />
            <select className="field col-span-2 sm:col-span-1" value={f.property_value} onChange={set("property_value")} data-testid="referral-value-select">
              <option value="">Property value</option>
              {PROPERTY_VALUES.map((v) => <option key={v} value={v}>{v}</option>)}
            </select>
            <select className="field col-span-2" value={f.timeline} onChange={set("timeline")} data-testid="referral-timeline-select">
              <option value="">Exchange timeline</option>
              {TIMELINES.map((v) => <option key={v} value={v}>{v}</option>)}
            </select>
            <textarea required rows={4} placeholder="Property, goals and anything the QI should know..." className="field col-span-2 resize-none" value={f.notes} onChange={set("notes")} data-testid="referral-notes-input" />
            <button disabled={busy} className="btn-pink col-span-2 mt-1" data-testid="referral-submit-button">{busy ? "Sending..." : "Send referral"}</button>
          </form>
        )}
      </DialogContent>
    </Dialog>
  );
};
